// src/components/Dashboard/AddEmployee.js
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { db } from '../../firebase/firebase';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from "firebase/firestore";

const AddEmployee = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    await addDoc(collection(db, 'employees'), {
      full_name: fullName,
      email: email,
    });

    navigate('/dashboard'); // Navigate back to dashboard
  };
  const handleCancel = () => {
    navigate('/dashboar'); // Go back to dashboard or any other page
  };
  return (
    <div>
      <h2>הוסף עובד חדש</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>שם מלא</label>
          <input
            type="text"
            className="form-control"
            placeholder="שם מלא"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>אימייל</label>
          <input
            type="email"
            className="form-control"
            placeholder="הכנס אימייל"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn-primary">הוסף</button>
        <Button variant="secondary" type="button" onClick={handleCancel}>
                  ביטול
                </Button>
      </form>
    </div>
  );
};

export default AddEmployee;
